export default __webpack_public_path__ + "static/pdp-results-in-days-a511681e344794f2516097a9aa2e6968.svg";